<template>
  <BaseModal
    :value="isOpen"
    :max-width="700"
    persistant
    :modal-title="$t('analyze_confirm_modal.title')"
    @close="$emit('close')"
  >
    <template #modal>
      <div class="text">
        {{ $t("analyze_confirm_modal.content") }}
      </div>
      <div class="text">
        {{ $tc("analyze_confirm_modal.content_1", multiple ? 2 : 1) }}
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="$emit('close')"
      >
        {{ $t("utils.back") }}
      </BaseButton>
      <BaseButton color="primary" type="primary" @click="$emit('validate')">
        {{ $t("utils.validate") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: "FolderConfirmExtractFileData",
  props: {
    isOpen: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 171.52%;
}
</style>
